import { Component, OnInit, ViewChild } from "@angular/core";
import { NgbAlert } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";
import { MsalService } from "@azure/msal-angular";
import { AuthenticationService } from "src/app/auth/services/authentication.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  public returnUrl!: string;
  @ViewChild("selfClosingAlert", { static: false }) selfClosingAlert!: NgbAlert;
  public isLoading: boolean = true;

  constructor(
    private router: Router,
    private authService: MsalService,
    private internalAuthService: AuthenticationService
  ) {}

  ngOnInit(): void {
    if (
      // sessionStorage.getItem("fkIdSesion") &&
      // sessionStorage.getItem("numeroSesion") &&
      sessionStorage.getItem("registrando") === "true"
    ) {
      this.router.navigate(["registrarAsistencia"]);
    } else {
      const accountCheck = setTimeout(async () => {
        const accounts = this.authService.instance.getAllAccounts();
        const uLog = accounts[0];
        if (uLog) {
          try {
            await this.internalAuthService.internalLogin(uLog.username);
            clearTimeout(accountCheck);
            this.isLoading = false;
            this.router.navigate(["/home"]);
          } catch (error) {
            this.router.navigate(["forbidden"]);
          } finally {
            this.isLoading = false;
          }
        } else {
          this.isLoading = false;
        }
      }, 1500);
    }
  }
  login() {
    this.authService.loginRedirect();
  }
}
